module.exports = __webpack_public_path__ + "img/IND-A-2-V.f86b215a.png";